import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function MaskedLines({ lines, className = "", lineClassName = "", delay = 0 }) {
  return (
    <div className={className}>
      {lines.map((line, i) => (
        <div key={i} className="overflow-hidden py-[0.08em] -my-[0.08em]">
          <motion.div
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.95, ease: EASE, delay: delay + i * 0.13 }}
            className={lineClassName}
          >
            {line}
          </motion.div>
        </div>
      ))}
    </div>
  );
}

export function FadeUp({ children, delay = 0, className = "", y = 36 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.75, ease: EASE, delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function CountUp({ to, prefix = "", suffix = "", duration = 1.8 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const start = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min((t - start) / (duration * 1000), 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(to * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, to, duration]);

  return (
    <span ref={ref}>
      {prefix}
      {val.toLocaleString("en-IE")}
      {suffix}
    </span>
  );
}

export function Marquee({ items, className = "", textClassName = "" }) {
  const row = items.join("  ·  ") + "  ·  ";
  return (
    <div className={`overflow-hidden whitespace-nowrap ${className}`} data-testid="editorial-marquee">
      <div className="marquee-track">
        <span className={`shrink-0 ${textClassName}`}>{row}</span>
        <span className={`shrink-0 ${textClassName}`}>{row}</span>
      </div>
    </div>
  );
}
